module.exports = __webpack_public_path__ + "static/version1-1-5fe6136f832fc1b507d2f6a50e19b763.png";